import Loading from "./Load.vue";

let obj = {
  install: function(Vue: any) {
    // 1 创建一个组件构造器(vue组件函数)
    const toastConstructor = Vue.extend(Loading);

    // 2 根据组件构造器，可以创建出来一个vue组件对象
    const Load = new toastConstructor();

    // 3 将组件对象，手动挂载到某个页面上
    Load.$mount(document.createElement("div"));
    document.body.appendChild(Load.$el);

    // 4 通过vue对象直接访问此插件
    Vue.prototype.$loading = Load;
  }
};

export default obj;
